import { render, staticRenderFns } from "./ManageTemplate.vue?vue&type=template&id=32a3c3c0&scoped=true"
import script from "./ManageTemplate.vue?vue&type=script&lang=js"
export * from "./ManageTemplate.vue?vue&type=script&lang=js"
import style0 from "./ManageTemplate.vue?vue&type=style&index=0&id=32a3c3c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a3c3c0",
  null
  
)

export default component.exports